import OptimizationPage from '@/modules/quant/optimization/optimization-page';
import { requireCapability } from '@/utils/route-guards';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_dashboard/dashboard/quant/optimization/',
)({
  beforeLoad: () => requireCapability('quantLab'),
  component: OptimizationPage,
});
